import React from "react"
import { Button, Col } from "react-bootstrap"
import Table, { AddButton } from "../../components/Table"
import Pending from "../../components/Pending"
import CreateConversionRuleModal from "./CreateConversionRuleModal"
import { useHistory } from "react-router-dom"
import { GetApi } from "../../api/api"

interface ConversionRulesListProps {
  conversionRules: ConversionRuleProps[]
}

export interface ConversionRuleProps {
  name: string
  id: string
  fc1Id: string
  fc2Id: string
}

const getConversionRules = (): Promise<ConversionRulesListProps> => GetApi()
  .then(api => api.getConversionRules())
  .then(conversionRules => conversionRules.map(cr => ({
    id: cr.id,
    name: cr.name,
    fc1Id: cr.sourceFeatureCatalog.id,
    fc2Id: cr.destinationFeatureCatalog.id
  })))
  .then(crs => ({
    conversionRules: crs
  }))

const createConversionRule = (rule: ConversionRuleProps): Promise<string> => GetApi()
  .then(api => api.createConversionRule({
    name: rule.name,
    // description?: string | undefined // Description not in UI yet
    sourceFeatureCatalogId: parseInt(rule.fc1Id, 10),
    destinationFeatureCatalogId: parseInt(rule.fc2Id, 10)
  }))
  .then(cr => cr.id)

const ConversionRulesRoute = () => {
  const pendingRef = React.useRef(null)
  const renderSuccess = (props: ConversionRulesListProps) => <ConversionRulesList {...props} />
  return <Pending ref={pendingRef} getData={getConversionRules} renderSuccess={renderSuccess} />
}

const ConversionRulesList = (props: ConversionRulesListProps) => {
  const { conversionRules } = props

  const [showCreateModal, setShowCreateModal] = React.useState(false)
  const closeCreateModal = () => setShowCreateModal(false)
  const toggleCreateModal = () => setShowCreateModal(!showCreateModal)

  const history = useHistory()

  const rowData = conversionRules
  const onRowClick = (index: number) => {
    const id = conversionRules[index]?.id
    history.push(`/conversionrules/${id}`)
    console.log("Clicked row")
  }
  const openCreateModal = toggleCreateModal
  const columnData = getColumnData(openCreateModal)

  return (
    <>
      {showCreateModal && (
        <CreateConversionRuleModal
          showModal={showCreateModal}
          closeModal={closeCreateModal}
          createConversionRule={createConversionRule}
        />
      )}
      {rowData.length > 0 ? (
        <Col xs={12} className="mb-3">
          <Table
            data={rowData}
            columns={columnData}
            onRowClick={onRowClick}
            // overrideSelected={overrideSelectedRow}
            defaultSorted={[
              {
                id: "modified",
                desc: true
              }
            ]}
          />
        </Col>
      ) : (
        <div className="my-auto text-center">
          <p className="display-4">Hi, there!</p>
          <p className="mb-4 text-muted">
            It seems like you haven't created a conversion rule yet, press the button to get started with your first
            conversion rule.
          </p>
          <Button variant="primary" onClick={openCreateModal}>
            Get started
          </Button>
        </div>
      )}
    </>
  )
}

const getColumnData = (create: () => void) => [
  {
    Header: "",
    accessor: "icon",
    width: 70,
    sortable: false
  },
  {
    Header: "Name",
    accessor: "name"
  },
  // {
  //   Header: "Role",
  //   accessor: "role"
  // },
  // {
  // Perhaps show which feature catalogs this conversion rule applies to?
  {
    Header: <AddButton onClick={create} /*disabled={this.state.disabled}*/ />,
    accessor: "action",
    width: 70,
    sortable: false
  }
]

export default ConversionRulesRoute
